var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.6H8.55556V9.6H5.5V6.6ZM9.77778 1.2H9.16667V0H7.94444V1.2H3.05556V0H1.83333V1.2H1.22222C0.55 1.2 0 1.74 0 2.4V10.8C0 11.46 0.55 12 1.22222 12H9.77778C10.45 12 11 11.46 11 10.8V2.4C11 1.74 10.45 1.2 9.77778 1.2ZM9.77778 2.4V3.6H1.22222V2.4H9.77778ZM1.22222 10.8V4.8H9.77778V10.8H1.22222Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarico);
export default __webpack_public_path__ + "static/media/calendarico.667c95d5b0f7e9fe4aa6ae4d2e328075.svg";
export { ForwardRef as ReactComponent };